import Vue from "vue";

import { Component, Prop } from "@/decorators";

@Component
export default class MoedaComSinalComponent extends Vue {
    @Prop(String) id: string;
    @Prop(String) name: string;
    @Prop(Number) value: number;
    @Prop({ type: Boolean, default: true }) showDifColor: boolean;

    private onBlur(value) {
        this.$emit("input", this.formatValueToModel(value));
    }

    private formatValueToModel(value) {
        return +value.replace("R$ ", "").replace(/\./g, "").replace(",", ".");
    }
}
